module.exports = __webpack_public_path__ + "static/img/achievement-dark.050d00d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/achievement-dark.png
// module id = OYO1
// module chunks = 9